import { FC } from 'react'
import { Route, Switch } from 'wouter'
import { observer } from 'mobx-react'

import { ResetPasswordPage } from '@/pages/ResetPasswordPage'
import { ChangePasswordPage } from '@/pages/ChangePasswordPage'
import { ErrorPage } from '@/pages/ErrorPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { SuccessPage } from '@/pages/SuccessPage'

export const ContentRouter: FC = observer(() => {
  return (
    <Switch>
      <Route path="/google" component={ResetPasswordPage} />
      <Route path="/google/set-password" component={ChangePasswordPage} />
      <Route path="/google/success" component={SuccessPage} />
      <Route path="/google/error" component={ErrorPage} />

      <Route path="/okta" component={ResetPasswordPage} />
      <Route path="/okta/set-password" component={ChangePasswordPage} />
      <Route path="/okta/success" component={SuccessPage} />
      <Route path="/okta/error" component={ErrorPage} />

      {/* Default route in a switch */}
      <Route component={NotFoundPage} />
    </Switch>
  )
})
